import createApiMiddlewareReducer from './utils/create-api-middleware-reducer'
import {
  REQUEST_CHECK_SOURCE_SLUG,
  REQUEST_CHECK_SOURCE_SLUG_ERROR,
  RECEIVE_CHECK_SOURCE_SLUG,
  RESET_CHECK_SOURCE_SLUG
} from 'actions'

const initialState = {}

const reducer = createApiMiddlewareReducer({
  receive: RECEIVE_CHECK_SOURCE_SLUG,
  failure: REQUEST_CHECK_SOURCE_SLUG_ERROR,
  request: REQUEST_CHECK_SOURCE_SLUG
}, initialState)

export default (state, action) => {
  if (action.type === RESET_CHECK_SOURCE_SLUG) {
    return initialState
  }

  return reducer(state, action)
}



// WEBPACK FOOTER //
// ./reducers/source-slug.js